export function getRandomAvatarColorStyles(): {
  background: string;
  font: string;
} {
  const colors = [
    {
      background: '#EBC2AD',
      font: '#B85C2E',
    },
    {
      background: '#D8ADEB',
      font: '#8D2EB8',
    },
    {
      background: '#B3B3C2',
      font: '#000033',
    },
    {
      background: '#A3CCC6',
      font: '#177365',
    },
    {
      background: '#ADCCA3',
      font: '#2E7317',
    },
    {
      background: '#CCC5A3',
      font: '#736217',
    },
    {
      background: '#FFE1B5',
      font: '#E6A340',
    },
    {
      background: '#B6B82E',
      font: '#EAEBAD',
    },
    {
      background: '#F0ADAA',
      font: '#C32E27',
    },
    {
      background: '#EBD4AD',
      font: '#B8852E',
    },
    {
      background: '#ADBEEB',
      font: '#2E54B8',
    },
    {
      background: '#C2ADEB',
      font: '#5C2EB8',
    },
    {
      background: '#A19D9B',
      font: '#140A05',
    },
    {
      background: '#BCAAA2',
      font: '#4E2714',
    },
    {
      background: '#ADE4EB',
      font: '#2E54B8',
    },
    {
      background: '#E6E6EB',
      font: '#140A05',
    },
  ];

  const randomColor = colors[Math.floor(Math.random() * colors.length)];

  return randomColor;
}

export function getParticipantsLoadClass(
  maxParticpants: number,
  currentParticipants: number
): string {
  const load = maxParticpants - currentParticipants;
  if (load >= 5) {
    return 'inwi-chip-text-green-outline';
  } else if (load >= 1) {
    return 'inwi-chip-text-yellow-outline';
  } else {
    return 'inwi-chip-text-red-outline';
  }
}
